<template>
    <div class="w-100" >
  
      <ui-modal
        ref="modal"
        :title="'Ver Detalle Recargo - ' + id"
        transition="scale-up"
        size="large"
        @close="closeModalEvent()"
      >
        <recargos-form 
          :closeModal="cerrarModal"
          :showReset="false"
          :id="id"
          :action="'update'"
          disabledForm
        />
      </ui-modal>
    </div>
  </template>
  
  <script>
  // Common
  import { mapActions,mapState } from "vuex";
  
  import RecargosForm from "./RecargosForm";
  
  export default {
    
    props:["id"],
  
    data() {
      return {
  
      };
    },
    methods: {
  
        ...mapActions(["ActionSetZindexTablaModal"]),
        ...mapActions("lineas", ["actionShowModalVerDetalleTarifasRecargo"]),
    
        openModal(ref) {
            this.ActionSetZindexTablaModal(true);
            this.$refs[ref].open();
        },
        closeModal(ref) {
            this.$refs[ref].close();
        },
        cerrarModal(){
            this.actionShowModalVerDetalleTarifasRecargo(false);
            this.ActionSetZindexTablaModal(false); 
            this.closeModal("modal");
        },
        closeModalEvent(){
          this.actionShowModalVerDetalleTarifasRecargo(false);
          this.ActionSetZindexTablaModal(false); 
        }
  
    },
    computed: {
    ...mapState("lineas", ["showModalVerDetalleTarifasRecargo"]),
      
    },
    components: {
      RecargosForm
    },
  
    watch: {
      showModalVerDetalleTarifasRecargo: function (_new) {
            _new && this.openModal("modal");
        },
    },
  };
  </script>
  
  <style>
  
  </style>
  